import React from 'react';
import {
  Route,
  Redirect,
  withRouter
} from 'react-router-dom'
import DashboardStructure from '../components/shared/DashboardStructure/DashboardStructure';
import ErrorBoundary from '../components/shared/ErrorBoundary';

const PrivateRoute = ({ component: Component, isAuthenticated, ...rest }) => {
  const token = localStorage.getItem('token');
  const [loading, setLoading] = React.useState(false);
  const [titlePage, setTitlePage] = React.useState('');

  return (
    <Route {...rest} render={(props) => (
      token
        ? (
          <DashboardStructure
            history={props.history}
            loading={loading}
            setLoading={setLoading}
            title={titlePage}
          >
            {/* Per-screen boundary INSIDE the shell, so one broken screen shows
                a message while the sidebar stays usable — rather than blanking
                the whole Admin Site. Keyed by pathname so navigating to another
                screen clears the error instead of staying stuck on it. */}
            <ErrorBoundary key={props.location.pathname}>
              <Component
                {...props}
                loading={loading}
                setLoading={setLoading}
                setTitlePage={setTitlePage}
              />
            </ErrorBoundary>
          </DashboardStructure>
        )
        : <Redirect to={{
          pathname: '/login',
          state: { from: props.location }
        }} />
    )} />
  )
}

export default withRouter(PrivateRoute);
